import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import coursesReducer from './CoursesReducer/coursesSlice';
import modulesReducer from './ModulesReducer/modulesSlice';
import liveSessionReducer from './LiveSessionReducer/liveSessionSlice';
import dashboardReducer from './DashboardReducer/dashboardSlice';
import accountsReducer from './AccountsReducer/accountsSlice';
import clustersReducer from './ClustersReducer/clustersSlice';
import institutionsReducer from './InstitutionsReducer/institutionsSlice';
import instructorsReducer from './InstructorReducer/instructorsSlice';
import staffReducer from './StaffReducer/staffSlice';
import sessionReducer from './SessionReducer/sessionSlice';
import videoIndexReducer from './VideoIndex/AdminVideoIndexReducer';
import videoUploadReducer from './VideoUpload/adminVideoUploadReducer';
import videoEditReducer from './VideoEdit/AdminVideoEditReducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    courses: coursesReducer,
    modules: modulesReducer,
    liveSession: liveSessionReducer,
    dashboard: dashboardReducer,
    accounts: accountsReducer,
    clusters: clustersReducer,
    institutions: institutionsReducer,
    instructors: instructorsReducer,
    staff: staffReducer,
    session: sessionReducer,
    videoIndex: videoIndexReducer,
    videoUpload: videoUploadReducer,
    videoEdit: videoEditReducer
  }
});
